import React, { useState } from "react";
import Modal from "react-modal";
import "./PopUpGetAward.scss";
import { ReactComponent as Coin } from "./../../../assets/svg/coin.svg";
import { ReactComponent as Arrow } from "./../../../assets/svg/arrow.svg";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useAuthValidation } from "../../../hooks/useAuthValidation";
import api from "../../../services/api";

Modal.setAppElement("#root");

function PopUpGetAward({ isOpen, closeModal, itemId, itemTitle, itemValue }) {
  const { t } = useTranslation();
  const { user, loading } = useAuthValidation();
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  if (loading) {
    return <div className="loading">{t("loading")}</div>;
  }

  if (!user) {
    return null;
  }

  const handleSubmit = async () => {
    try {
      await api.post("/store/request", { product_id: itemId });
      navigate("/premio-resgatado");
    } catch (error) {
      console.error("Erro:", error);
      setError(t("error-get-award"));
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={closeModal}
      contentLabel={t("get-award-modal")}
      className="get-award"
    >
      <button onClick={closeModal} className="row link">
        <Arrow />
        {t("go-back")}
      </button>
      <div>
        <h2>{t("pop-up-get-award")}</h2>
        <span>{itemTitle}</span>
        <div className="row">
          <Coin />
          <span>-{itemValue}</span>
        </div>
        {error && <p className="error">{error}</p>}
        <button className="button" onClick={handleSubmit}>
          {t("pop-up-get-award-button")}
        </button>
      </div>
    </Modal>
  );
}

export default PopUpGetAward;
